import React, { useContext } from 'react';
import { Route, Routes as Switch } from 'react-router-dom';

import AuthContext from '../contexts/AuthContext';
import Home from '../components/Home';
import Account from '../components/account';
import Assets from '../components/Assets';
import Asset from '../components/Assets/show';
import Reports from '../components/Reports';
import PastSaleReports from '../components/Reports/PastSaleReports';
import Sale from '../components/Sales/show';
import SellerUsers from '../components/SellerUsers';
import FeeEstimate from '../components/Fees/FeeEstimates/show';

const Routes = () => {
  const { role } = useContext(AuthContext);

  return (
    <Switch>
      <Route path="/" element={<Home />} exact />
      <Route path="/sellers/:id" element={<Home />} exact />
      <Route path="/account" element={<Account />} exact />
      <Route path="/assets" element={<Assets />} exact />
      <Route path="/assets/:id" element={<Asset />} exact />
      <Route path="/reports" element={<Reports />} exact />
      <Route path="/reports/sale" element={<PastSaleReports />} exact />
      <Route path="/assets/:assetId/fee-estimates/:feeEstimateId"
        element={<FeeEstimate />} exact />
      <Route path="/sales/:id" element={<Sale />} exact />
      <Route path="/sales/:id/asset/:saleAssetId" element={<Sale />} exact />
      <Route path="/sales/:id/:tableType" element={<Sale />} exact />
      <Route path="/users" element={<SellerUsers />} exact />
    </Switch>
  );
}

export default Routes;
